/* Belovely landing — occasion preview browser.
   6 occasions, each with 3 hand-paired genre+mood combos. Each combo plays its
   real generated song (75s preview, starting at the chorus) from assets/songs/. */

(function () {
  // resolve flat asset names to Shopify CDN URLs (config.js); local fallback otherwise
  const asset = (window.BELOVELY && window.BELOVELY.asset) || ((n) => "assets/" + n);
  // slug matches backend/prototype/generate_previews.py (e.g. "mothers-rb-heartfelt")
  const songSlug = (occKey, genre, mood) =>
    `${occKey}-${genre.toLowerCase().replace(/&/g, "").replace(/\//g, "-").replace(/ /g, "")}-${mood.toLowerCase()}`;
  const songFor = (occKey, genre, mood) => asset(`${songSlug(occKey, genre, mood)}.mp3`);

  // gradient pair per occasion
  const G = {
    mothers:     ["#E8A87C", "#C38D9E"],
    fathers:     ["#5E7A8C", "#365061"],
    anniversary: ["#E07A5F", "#B5546A"],
    birthday:    ["#F4A259", "#F25C54"],
    just:        ["#85B79D", "#5E8C77"],
    memorial:    ["#7E8FA6", "#4A5A6E"],
  };

  const OCCASIONS = [
    {
      key: "mothers", label: "Mother's Day", emoji: "🌷", grad: G.mothers,
      name: "Mother's Day",
      blurb: "She has given everything. Give her a song that says what a card never could.",
      bullets: ["Lyrics inspired by your real memories", "A gift that will make her cry happy tears", "More meaningful than anything you can buy"],
      combos: [
        { genre: "R&B", mood: "Heartfelt", title: "Everything You Gave" },
        { genre: "Acoustic", mood: "Reflective", title: "The Quiet Years" },
        { genre: "Pop", mood: "Grateful", title: "Thank You, Mom" },
      ],
    },
    {
      key: "fathers", label: "Father's Day", emoji: "🎣", grad: G.fathers,
      name: "Father's Day",
      blurb: "Dads are tough to shop for. But a song about who he is and what he means? That gets him every time.",
      bullets: ["Captures the moments that made him Dad", "A gift he'll actually listen to again", "The surprise that finally gets him emotional"],
      combos: [
        { genre: "Country", mood: "Reflective", title: "The Things You Carried" },
        { genre: "Acoustic", mood: "Heartfelt", title: "My Safe Harbor" },
        { genre: "Rock", mood: "Proud", title: "Everything I Know" },
      ],
    },
    {
      key: "anniversary", label: "Anniversary", emoji: "💍", grad: G.anniversary,
      name: "Anniversary",
      blurb: "All those years, in one song — the story only the two of you share.",
      bullets: ["Your story, from the first day to now", "The detail that makes them gasp", "A keepsake you'll replay every year"],
      combos: [
        { genre: "R&B", mood: "Romantic", title: "Still You, Always" },
        { genre: "Pop", mood: "Heartfelt", title: "I'd Choose You" },
        { genre: "Acoustic", mood: "Tender", title: "The Small Unspoken" },
      ],
    },
    {
      key: "birthday", label: "Birthday", emoji: "🎂", grad: G.birthday,
      name: "Birthday",
      blurb: "Forget another gift card. Celebrate them with a song made only for them.",
      bullets: ["Built around what makes them, them", "The birthday surprise nobody expects", "Yours to keep long after the candles"],
      combos: [
        { genre: "Pop", mood: "Joyful", title: "The World With You In It" },
        { genre: "R&B", mood: "Upbeat", title: "Light Up the Room" },
        { genre: "Acoustic", mood: "Warm", title: "Glad You're Here" },
      ],
    },
    {
      key: "just", label: "Just Because", emoji: "💛", grad: G.just,
      name: "Just Because",
      blurb: "No occasion needed. Sometimes “I was thinking about you” is the whole reason.",
      bullets: ["The ordinary days, made unforgettable", "A love note they can press play on", "Because they don't have to earn it"],
      combos: [
        { genre: "Acoustic", mood: "Tender", title: "Ordinary Hours" },
        { genre: "R&B", mood: "Romantic", title: "No Reason Needed" },
        { genre: "Folk", mood: "Warm", title: "Just You, Just This" },
      ],
    },
    {
      key: "memorial", label: "Memorial", emoji: "🕊️", grad: G.memorial,
      name: "In Memory",
      blurb: "Some people never really leave us. Keep their memory close with a song in their honor.",
      bullets: ["Their story, lovingly preserved", "A tribute the whole family can share", "Comfort you can return to anytime"],
      combos: [
        { genre: "Acoustic", mood: "Reflective", title: "Carry You With Me" },
        { genre: "Worship", mood: "Tender", title: "Until I See You Again" },
        { genre: "Country", mood: "Heartfelt", title: "Always Here" },
      ],
    },
  ];

  // full occasion list for the showcase grid (previews exist for the 6 above;
  // the rest are visual tiles for now — real previews/images added later).
  const OCCASIONS_ALL = [
    { key: "fathers", label: "Father's Day", emoji: "🎣", grad: ["#5E7A8C", "#365061"] },
    { key: "anniversary", label: "Anniversary", emoji: "💍", grad: ["#E07A5F", "#B5546A"] },
    { key: "birthday", label: "Birthday", emoji: "🎂", grad: ["#F4A259", "#F25C54"] },
    { key: "just", label: "Just Because", emoji: "💛", grad: ["#85B79D", "#5E8C77"] },
    { key: "memorial", label: "In Memory", emoji: "🕊️", grad: ["#7E8FA6", "#4A5A6E"] },
    { key: "wedding", label: "Wedding", emoji: "💒", grad: ["#D9A7A7", "#A8757F"] },
    { key: "prayer", label: "Prayer", emoji: "🤲", grad: ["#D6A98C", "#9A7B6A"] },
    { key: "thankyou", label: "Thank You", emoji: "🙏", grad: ["#E0A95F", "#C2823A"] },
    { key: "missingyou", label: "Missing You", emoji: "🤍", grad: ["#8A93B0", "#5A6488"] },
  ];

  // photos for the GRID tiles
  const OCC_IMG = {
    fathers: "occ-fathers.jpg",
    anniversary: "occ-anniversary.jpg",
    birthday: "occ-birthday.jpg",
    just: "occ-just.jpg",
    memorial: "occ-memorial.jpg",
    wedding: "occ-wedding.jpg",
    missingyou: "occ-missingyou.jpg",
    thankyou: "occ-thankyou.jpg",
    prayer: "occ-prayer.webp",
  };

  // photos for the SONG-PREVIEW cards (dedicated thumbnails; can differ from grid)
  const PREVIEW_IMG = {
    mothers: "preview-mothers.jpg",     // new
    fathers: "preview-fathers.jpg",     // replaced
    just: "preview-just.webp",          // replaced
    anniversary: "occ-anniversary.jpg",
    birthday: "occ-birthday.jpg",
    memorial: "occ-memorial.jpg",
  };

  const $ = (id) => document.getElementById(id);
  let occIdx = 0, comboIdx = 0;

  const audio = $("pcardAudio");
  const PLAY = '<path d="M8 5v14l11-7z"/>';
  const PAUSE = '<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>';
  function fmt(s){ s=Math.max(0,Math.floor(s||0)); return Math.floor(s/60)+":"+String(s%60).padStart(2,"0"); }

  // ---- build occasion nav ----
  $("occNav").innerHTML = OCCASIONS.map((o,i) =>
    `<button class="bel-occnav__btn ${i===0?"is-active":""}" data-i="${i}">${o.emoji} ${o.label}</button>`
  ).join("");
  $("occNav").querySelectorAll(".bel-occnav__btn").forEach(b =>
    b.addEventListener("click", () => selectOccasion(parseInt(b.dataset.i,10)))
  );

  // ---- build occasion grid ----
  $("occGrid").innerHTML = OCCASIONS_ALL.map(o => {
    const bg = OCC_IMG[o.key]
      ? `background-image:url('${asset(OCC_IMG[o.key])}')`
      : `--g1:${o.grad[0]};--g2:${o.grad[1]}`;
    return `<div class="bel-occgrid__tile" data-key="${o.key}" style="${bg}"><span>${o.emoji} ${o.label}</span></div>`;
  }).join("");
  $("occGrid").querySelectorAll(".bel-occgrid__tile").forEach(t =>
    t.addEventListener("click", () => {
      const idx = OCCASIONS.findIndex(o => o.key === t.dataset.key);
      if (idx >= 0) selectOccasion(idx);   // has a live preview
      document.querySelector(".bel-pcard").scrollIntoView({ behavior:"smooth", block:"center" });
    })
  );

  function selectOccasion(i) {
    occIdx = i; comboIdx = 0;
    $("occNav").querySelectorAll(".bel-occnav__btn").forEach((b,bi) => b.classList.toggle("is-active", bi===i));
    const o = OCCASIONS[i];
    const pc = $("pcard");
    pc.style.setProperty("--g1", o.grad[0]);
    pc.style.setProperty("--g2", o.grad[1]);
    pc.style.backgroundImage = PREVIEW_IMG[o.key] ? `url('${asset(PREVIEW_IMG[o.key])}')` : "";
    $("occName").textContent = o.name;
    $("occBlurb").textContent = o.blurb;
    $("occBullets").innerHTML = o.bullets.map(b => `<li>${b}</li>`).join("");
    buildCombos();
    selectCombo(0);
  }

  function buildCombos() {
    const o = OCCASIONS[occIdx];
    $("combos").innerHTML = o.combos.map((c,ci) =>
      `<button class="bel-combo ${ci===0?"is-active":""}" data-i="${ci}"><span class="bel-combo__g">${c.genre}</span><span class="bel-combo__m">${c.mood}</span></button>`
    ).join("");
    $("combos").querySelectorAll(".bel-combo").forEach(b =>
      b.addEventListener("click", () => selectCombo(parseInt(b.dataset.i,10)))
    );
  }

  function selectCombo(ci) {
    comboIdx = ci;
    const o = OCCASIONS[occIdx], c = o.combos[ci];
    $("combos").querySelectorAll(".bel-combo").forEach((b,bi) => b.classList.toggle("is-active", bi===ci));
    $("pcardTags").textContent = `${o.label.toUpperCase()} · ${c.genre} · ${c.mood}`;
    $("pcardTitle").textContent = c.title;
    $("pcardSub").textContent = `A ${c.mood.toLowerCase()} ${c.genre} song`;
    audio.pause();
    audio.src = songFor(o.key, c.genre, c.mood);
    $("pcardIcon").innerHTML = PLAY;
    $("pcardFill").style.width = "0%";
    $("pcardCur").textContent = "0:00";
    $("pcardDur").textContent = "0:00";
  }

  // ---- player ----
  $("pcardPlay").addEventListener("click", () => { audio.paused ? audio.play() : audio.pause(); });
  audio.addEventListener("play", () => { $("pcardIcon").innerHTML = PAUSE; });
  audio.addEventListener("pause", () => { $("pcardIcon").innerHTML = PLAY; });
  audio.addEventListener("loadedmetadata", () => { $("pcardDur").textContent = fmt(audio.duration); });
  audio.addEventListener("timeupdate", () => {
    const d = audio.duration || 1;
    $("pcardFill").style.width = (audio.currentTime/d*100) + "%";
    $("pcardCur").textContent = fmt(audio.currentTime);
  });
  audio.addEventListener("ended", () => { $("pcardIcon").innerHTML = PLAY; });

  // ---- reaction reels ----
  // 2-col grid. ALL reels autoplay + loop, MUTED by default. Tapping a reel
  // unmutes it and re-mutes whichever was unmuted before (only one has sound).
  // When real videos arrive, put inside each .bel-reel (replacing the .ph):
  //   <video src="..." autoplay muted loop playsinline></video>
  // and this logic drives the `muted` flag on tap.
  const REELS = 10;
  const reactionRow = $("reactionRow");
  const reels = [];
  let unmutedIdx = -1;
  if (reactionRow) {
    reactionRow.innerHTML = "";
    for (let i = 0; i < REELS; i++) {
      const el = document.createElement("div");
      el.className = "bel-reel";
      el.innerHTML =
        `<video src="${asset('reaction-' + (i + 1) + '.mp4')}" autoplay muted loop playsinline preload="metadata"></video>` +
        `<span class="bel-reel__mute">🔇</span>`;
      reactionRow.appendChild(el);
      reels.push({ el, muteBtn: el.querySelector(".bel-reel__mute") });
      el.addEventListener("click", () => tapReel(i));
      const v = el.querySelector("video");
      if (v) { v.muted = true; v.play().catch(()=>{}); }
    }
  }
  function setUnmuted(i, on) {
    const r = reels[i]; if (!r) return;
    r.el.classList.toggle("is-unmuted", on);
    r.muteBtn.textContent = on ? "🔊" : "🔇";
    const v = r.el.querySelector("video");
    if (v) v.muted = !on;
  }
  function tapReel(i) {
    if (unmutedIdx === i) { setUnmuted(i, false); unmutedIdx = -1; return; } // tap active -> silence
    if (unmutedIdx >= 0) setUnmuted(unmutedIdx, false);                       // mute previous
    setUnmuted(i, true); unmutedIdx = i;                                      // unmute this one
  }

  // ---- hero video (loops, persistent corner mute toggle) ----
  const heroVideo = $("heroVideo"), heroMute = $("heroMute");
  if (heroVideo && heroMute) {
    heroVideo.muted = true;
    heroVideo.play().catch(()=>{});
    heroMute.addEventListener("click", () => {
      heroVideo.muted = !heroVideo.muted;
      heroMute.textContent = heroVideo.muted ? "🔇 Tap to unmute" : "🔊 Tap to mute";
    });
  }

  // ---- go ----
  selectOccasion(0);
})();
